import { ReactSelectOptionsType } from "../components/payroll/AddPayroll"
import { DropdownSelectionType, FORM_ELEMENTS, PAYROLL_FIELD_KEY_NAMES } from "../constants/Enums"


interface DropdownTag {
    selectionType: DropdownSelectionType;
    type: FORM_ELEMENTS;
    defaultValue?: ReactSelectOptionsType;
    hidden: boolean;
    value: ReactSelectOptionsType;
    key: PAYROLL_FIELD_KEY_NAMES;
    options?: ReactSelectOptionsType[];
    isMandatory? : boolean
}

interface InputTag {
    value: string | number;
    hidden: boolean;
    key: PAYROLL_FIELD_KEY_NAMES;
    type: FORM_ELEMENTS;
    defaultValue?: number | string;
    hasError: boolean;
    isDisabled?: boolean;
    isMandatory?: boolean;
}
export interface Payroll {
    payschedule: DropdownTag;
    payableAccount?: DropdownTag;
}
export interface NewPayrollState {
    payschedule: DropdownTag,
    payPeriod: DropdownTag,
    payDay: DropdownTag,
    payDate: DropdownTag,
    workPeriod: DropdownTag,
    applicableTo: boolean
}

export const initialCreatePayrollFormValues: NewPayrollState = {
    payschedule : {
        key: PAYROLL_FIELD_KEY_NAMES.PAY_SCHEDULE,
        hidden: false,
        value: { label: '', value: '' },
        selectionType: DropdownSelectionType.SINGLE,
        type: FORM_ELEMENTS.DROPDOWN,
        isMandatory: true
    },
    payPeriod: {
        key: PAYROLL_FIELD_KEY_NAMES.PAY_PERIOD,
        hidden: false,
        value: { label: '', value: '' },
        selectionType: DropdownSelectionType.SINGLE,
        type: FORM_ELEMENTS.DROPDOWN,
        isMandatory: true
    },
    payDay: {
        key: PAYROLL_FIELD_KEY_NAMES.PAY_DAY,
        hidden: false,
        value: { label: '', value: '' },
        selectionType: DropdownSelectionType.SINGLE,
        type: FORM_ELEMENTS.DROPDOWN,
        isMandatory: true
    },
    payDate: {
        key: PAYROLL_FIELD_KEY_NAMES.PAY_DATE,
        hidden: false,
        value: { label: '', value: '' },
        selectionType: DropdownSelectionType.SINGLE,
        type: FORM_ELEMENTS.DROPDOWN,
        isMandatory: true
    },
    workPeriod: {
        key: PAYROLL_FIELD_KEY_NAMES.WORK_PERIOD,
        hidden: false,
        value: { label: '', value: '' },
        selectionType: DropdownSelectionType.SINGLE,
        type: FORM_ELEMENTS.DROPDOWN,
        isMandatory: true
    },
    applicableTo: false
}

export const PAY_PERIOD = [
    {
        id: "0",
        name: "Monthly"
    }
]

export interface ADD_PAYROLL_DATA_TO_SAVE {
    countryCode: string,
    tenantId: number,
    deleted: boolean,
    payrunType: number,
    paySchedule: {
        id: string,
        name: string
    },
    payPeriod:string,
    workWeek: [],
    payDay: string,
    firstPayDate: string,
    payDate: string,
    workPeriod: {
        from: string,
        to: string
    },
    isForAllUsers: boolean,
    employees: any[],
    location: number
    _id?: string,
    customFields: any[]
}